/*
 * Scenario-Registry — alle bekannten Scenarios werden hier eingetragen.
 *
 * Die Liste wird von /mock list in der Konsole angezeigt und von
 * MockAgentTransport.loadScenario(name) als Lookup genutzt.
 *
 * Scenario-Module exportieren { name, description, run(state) }.
 */

import * as rewriteSingle from './rewrite-single.js'
import * as rewriteMulti from './rewrite-multi.js'
import * as insertAfterCursor from './insert-after-cursor.js'
import * as insertAtStart from './insert-at-start.js'
import * as insertEnd from './insert-end.js'
import * as deleteCursor from './delete-cursor.js'
import * as deleteMulti from './delete-multi.js'
import * as mixedSequence from './mixed-sequence.js'
import * as versionMismatch from './version-mismatch.js'
import * as abortMidReview from './abort-mid-review.js'
import * as acceptThenUndo from './accept-then-undo.js'
import * as longReview from './long-review.js'
import * as remoteChangeDuringReview from './remote-change-during-review.js'
// Phase 3
import * as sketchEmptySection from './sketch-empty-section.js'
import * as writeNoteEdit from './write-note-edit.js'
// Markdown-First Format-Demos (2026-05-02)
import * as rewriteWithFormats from './rewrite-with-formats.js'
import * as insertHeading from './insert-heading.js'
// F1: Inline-Code (2026-05-03)
import * as rewriteWithCode from './rewrite-with-code.js'

const SCENARIOS = [
    rewriteSingle,
    rewriteMulti,
    insertAfterCursor,
    insertAtStart,
    insertEnd,
    deleteCursor,
    deleteMulti,
    mixedSequence,
    versionMismatch,
    abortMidReview,
    acceptThenUndo,
    longReview,
    remoteChangeDuringReview,
    // Phase 3
    sketchEmptySection,
    writeNoteEdit,
    // Markdown-First Format-Demos
    rewriteWithFormats,
    insertHeading,
    // F1
    rewriteWithCode
]

/**
 * @returns {Array<{name: string, description: string}>} fuer /mock list
 */
export function listScenarios() {
    return SCENARIOS.map(s => ({ name: s.name, description: s.description }))
}

/**
 * Liefert das Scenario-Modul zum Namen oder undefined.
 * @param {string} name
 * @returns {{name: string, description: string, run: Function}|undefined}
 */
export function getScenario(name) {
    return SCENARIOS.find(s => s.name === name)
}
